/*/
 * Form validation
/*/
	window.addEventListener('load', _ => {
		'use strict'

		const forms = document.querySelectorAll('[site-validate]')
		Array.from(forms).forEach(function (form) {
			form.addEventListener('submit', function (event) {
				const button = this.querySelector('[type=submit]')
				const fieldset = this.querySelector('fieldset')
				const formReturnSuccess = form.dataset.success
				const formReturnError = form.dataset.error

				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()

					const invalid = this.querySelector(':invalid')
					invalid.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'center'
					})
					setTimeout(() => {
						invalid.focus()
					}, 750);
				} else {
					event.preventDefault()

					const data = new FormData(this)
					const select = form.querySelectorAll('select')

					button.classList.add('is--loading')
					if (fieldset) { fieldset.disabled = true }
					button.disabled = true

					const options = {
						headers: { 'Content-Type': 'multipart/form-data' }
					}

					window.axios.post(this.action, data, options)
					.then(_ => {
						form.reset()

						if (select.length > 0) {
							select.forEach(s => s.classList.remove('is--selected'))
						}

						form.classList.remove('is--validated')

						siteAlert({
							text: formReturnSuccess,
							class: 'alert--i_success',
							seconds: 12000
						})
					}).catch(err => {
						console.error(err)

						siteAlert({
							text: formReturnError,
							class: 'alert--i_error',
							seconds: 7000
						})
					}).finally(_ => {
						setTimeout(() => {
							button.classList.remove('is--loading')
							button.disabled = false
							if (fieldset) { fieldset.disabled = false }
						}, 2000);
					})
				}

				form.classList.add('is--validated')
			}, false)
		})
	})

/*/
 * CPF Validation
/*/
	// const validateCPF = cpf => {
	// 	const val = cpf.replaceAll('.', '').replaceAll('-', '')

	// 	let sum = 0;
	// 	let rem;

	// 	if (val == "00000000000") return false;

	// 	for (let i = 1; i <= 9; i++) sum = sum + parseInt(val.substring(i - 1, i)) * (11 - i);
	// 	rem = (sum * 10) % 11;

	// 	if ((rem == 10) || (rem == 11)) rem = 0;
	// 	if (rem != parseInt(val.substring(9, 10))) return false;

	// 	sum = 0;
	// 	for (let i = 1; i <= 10; i++) sum = sum + parseInt(val.substring(i - 1, i)) * (12 - i);
	// 	rem = (sum * 10) % 11;

	// 	if ((rem == 10) || (rem == 11)) rem = 0;
	// 	if (rem != parseInt(val.substring(10, 11))) return false;
	// 	return true;
	// }

	// const formCpfFields = document.querySelectorAll('[data-mask="cpf"]')
	// if (formCpfFields) {
	// 	formCpfFields.forEach(e => {
	// 		e.addEventListener('keyup', function () {
	// 			const validateFieldCPF = validateCPF(this.value)
	// 			let valid = this.checkValidity()

	// 			if (!validateFieldCPF) {
	// 				e.setCustomValidity('CPF Inválido')
	// 				valid = this.checkValidity()
	// 			} else {
	// 				e.setCustomValidity('')
	// 				valid = this.checkValidity()
	// 			}
	// 		})
	// 	})
	// }
